import logger from '../utils/logger';
import { storage } from '../utils/storage';

const originApiUrl = () =>
    (typeof window !== 'undefined' && window.location?.origin
        ? `${window.location.origin.replace(/\/$/, '')}/api`
        : '/api');

let currentApiBaseUrl = originApiUrl();

const readConfiguredBaseUrl = (configData) => {
    if (!configData || typeof configData !== 'object') return '';
    const raw =
        configData.apI_BASE_URL ||
        configData.aPI_BASE_URL ||
        configData.apiBaseUrl ||
        configData.API_BASE_URL ||
        '';
    return typeof raw === 'string' ? raw.trim() : '';
};

async function loadConfig() {
    try {
        const response = await fetch('/api/config', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            cache: 'no-cache',
        });

        if (!response?.ok) {
            logger.warn(`Configuration endpoint returned HTTP ${response?.status || 'unknown'}; using ${currentApiBaseUrl}`);
            return;
        }

        const configData = await response.json();
        const configured = readConfiguredBaseUrl(configData);
        const host = typeof window !== 'undefined' ? window.location.hostname : '';
        const isLocal = host === 'localhost' || host === '127.0.0.1';

        if (configured && !isLocal) {
            currentApiBaseUrl = `${configured.replace(/\/$/, '')}/api`;
        } else {
            currentApiBaseUrl = originApiUrl();
        }

        logger.info('Configuration loaded successfully');
    } catch (error) {
        currentApiBaseUrl = originApiUrl();
        logger.error('Failed to load configuration; using current origin', error);
    }
}

const configLoadPromise = loadConfig();

// Template literals call toString(), so `${API_BASE_URL}/Master/...` always
// reads the latest URL even if webpack copied the export at import time.
const API_BASE_URL = {
    toString() {
        return currentApiBaseUrl;
    },
    valueOf() {
        return currentApiBaseUrl;
    },
};

async function getAuthHeader() {
    try {
        await configLoadPromise;

        if (!currentApiBaseUrl) {
            currentApiBaseUrl = originApiUrl();
        }

        const token = storage.getItem('token');

        if (!token || typeof token !== 'string' || token.trim() === '') {
            const error = new Error('UNAUTHORIZED: JWT token not found.');
            error.isAuthError = true;
            logger.warn('Authentication token not found');
            throw error;
        }

        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token.trim()}`,
        };
    } catch (error) {
        logger.error('Error getting auth header:', error);
        throw error;
    }
}

export { API_BASE_URL, getAuthHeader };
